import React, { useContext } from 'react';
import AppContext from 'context/Context';

const TicketsFilterTabs = ({ filterTab, setFilterTab, counts = {}, isMobile = false }) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { pendientes = 0, enProgreso = 0, cerrados = 0 } = counts;

  const tabs = [
    { id: 'pendientes', label: 'Pendientes', count: pendientes },
    { id: 'en_progreso', label: 'En Progreso', count: enProgreso },
    { id: 'resueltos', label: isMobile ? 'Resueltos' : 'Resueltos en las últimas 24h', count: cerrados }
  ];

  return (
    <div
      className={`d-inline-flex align-items-center p-1 rounded-3 shadow-none flex-nowrap ${isMobile ? 'w-100' : ''}`}
      style={{
        backgroundColor: isDark ? '#16222f' : '#e8edf3',
        border: isDark ? '1px solid #233142' : 'none',
        whiteSpace: 'nowrap'
      }}
    >
      {tabs.map(tab => {
        const isActive = filterTab === tab.id || (tab.id === 'resueltos' && filterTab === 'cerrados');
        const isEnProgreso = tab.id === 'en_progreso';
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => setFilterTab(tab.id)}
            className={`btn btn-sm d-inline-flex align-items-center justify-content-center gap-1.5 rounded-3 border-0 py-1.5 text-nowrap transition-base shadow-none ${
              isMobile ? 'flex-fill px-2' : 'px-3'
            }`}
            style={{
              fontSize: '0.80rem',
              fontWeight: isActive ? 700 : 500,
              backgroundColor: isActive
                ? (isDark ? '#1e293b' : '#ffffff')
                : 'transparent',
              color: isActive
                ? (isDark ? '#f8fafc' : '#0f172a')
                : (isDark ? '#94a3b8' : '#64748b'),
              boxShadow: isActive
                ? (isDark ? '0 1px 3px rgba(0,0,0,0.3)' : '0 1px 3px rgba(0,0,0,0.08)')
                : 'none',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            <span>{tab.label}</span>
            {isMobile && isActive && isEnProgreso ? (
              <span
                className="rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: '18px',
                  height: '18px',
                  fontSize: '0.68rem',
                  backgroundColor: isDark ? 'rgba(34, 197, 94, 0.25)' : '#dcfce7',
                  color: isDark ? '#4ade80' : '#15803d',
                  fontWeight: 700
                }}
              >
                {tab.count ?? 0}
              </span>
            ) : (
              <span
                className="flex-shrink-0"
                style={{
                  fontSize: '0.78rem',
                  color: isActive ? (isDark ? '#94a3b8' : '#64748b') : (isDark ? '#64748b' : '#94a3b8'),
                  fontWeight: 500
                }}
              >
                ({tab.count ?? 0})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default TicketsFilterTabs;